import { Api } from '@/services/AxiosService'

const actions = {
  async loginUser(ctx, formData) {
    const res = await Api.loginUser(formData)
    console.log(res)
    //ctx.commit('setUserInfo', res.data.data)
    return Promise.resolve(res)
  },
  async registerUser(ctx, formData) {
    const res = await Api.registerUser(formData)
    ctx.commit('setUserInfo', res.data.data)
    return Promise.resolve(res)
  },
  async verifyPhone(ctx, formData) {
    const POST = {
      ...formData,
      phone: ctx.getters.getUserInfo.phone,
    }
    const res = await Api.verifyPhone(POST)
    return Promise.resolve(res)
  },
  async fetchMeInfo(ctx) {
    const token = localStorage.getItem('token')
    if (!token) return

    const res = await Api.fetchMeInfo()
    ctx.commit('setUserInfo', res.data.data)
    return Promise.resolve(res)
  },
  async logOutUser(ctx) {
    const res = await Api.logOutUser()
    ctx.commit('setUserInfo', {})
    return Promise.resolve(res)
  },
  async forgotPasswordSMS(ctx, data) {
    const res = await Api.forgotPasswordSMS(data)
    return Promise.resolve(res)
  },
  async resetPassword(ctx, data) {
    const res = await Api.resetPassword(data)
    return Promise.resolve(res)
  },
}
const mutations = {
  setUserInfo(state, data) {
    state.me = data
  },
  setLoginModalVisibility(state, value) {
    state.loginModalVisible = value
  },
}
const getters = {
  getUserInfo(state) {
    return state.me
  },
  getLoginModalVisibility(state) {
    return state.loginModalVisible
  },
}
const state = {
  me: {},
  loginModalVisible: false,
}

export default {
  state,
  getters,
  mutations,
  actions,
}
